import { render, staticRenderFns } from "./IconHeartOutline.vue?vue&type=template&id=33a6de46&scoped=true&"
import script from "./IconHeartOutline.vue?vue&type=script&lang=ts&"
export * from "./IconHeartOutline.vue?vue&type=script&lang=ts&"
import style0 from "./IconHeartOutline.vue?vue&type=style&index=0&id=33a6de46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a6de46",
  null
  
)

export default component.exports